










































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { PlanHeader } from "@/entity/Ppe/PlanHeader";
import { GetDropDownListBySource, SOURCE } from "@/services/PpeDropDowns";
import PlanProductsManage from "./PlanProductsManage.vue";
import { PPE_PRODUCT_TYPE } from "@/services/Enums";

@Component({
    components: {
        PlanProductsManage,
    }
})
export default class PlanGeneralInfo extends Vue {
    @Prop({ type: Boolean, required: true })
    planHeaderEditable;
    @Prop({ type: Boolean, required: true })
    planDetailEditable;
    @Prop({ required: true })
    planProp;
    @Prop({ type: Array, required: true })
    dropDownCountries: [];
    @Prop({ type: Boolean, required: true })
    isSaveClicked;
    @Prop({ type: Boolean, required: true })
    isSaveDraftClicked;

    plan: PlanHeader = new PlanHeader();

    entityMounted: boolean = false;

    dropDownTargetCustomer1: any = new Array();
    dropDownTargetCustomer2: any = new Array();
    dropDownMechanics: any = new Array();
    dropDownModality: any = new Array();

    PRODUCT_TYPE = PPE_PRODUCT_TYPE;

    async mounted() {
        this.plan = this.planProp;
        if(this.plan.number == null) {
            this.plan.number = '-';
        }
        if(this.plan.detail.allBrands == null) {
            this.plan.detail.allBrands = false;
        }
        this.entityMounted = true;
        await this.InitDropDown();
    }

    async InitDropDown() {
        this.dropDownTargetCustomer1 = await GetDropDownListBySource(SOURCE.TARGET_CUSTOMER_1);
        this.dropDownTargetCustomer2 = await GetDropDownListBySource(SOURCE.TARGET_CUSTOMER_2);
        this.dropDownMechanics = await GetDropDownListBySource(SOURCE.MECHANICS);
        this.dropDownModality = await GetDropDownListBySource(SOURCE.MODALITY);
    }

    returnState(condition: boolean, clickButton: boolean): boolean {
        if (clickButton) 
            return condition;
        else 
            return null;
    }
}
